import type { AvailabilityStatus } from '@psp-aggregator/sdk';
import sdk from '@psp-aggregator/sdk';
import { keepPreviousData } from '@tanstack/react-query';

export interface UseProvidersParams {
  country?: string[];
  currency?: string[];
  enabled?: boolean;
  industry?: string[];
  integrationMethod?: string[];
  isDeleted?: boolean;
  limit?: number;
  page?: number;
  paymentMethod?: string[];
  search?: string;
  status?: AvailabilityStatus;
}

export const useProviders = ({
  country,
  currency,
  enabled = true,
  industry,
  integrationMethod,
  isDeleted,
  limit,
  page,
  paymentMethod,
  search,
  status,
}: UseProvidersParams = {}) =>
  sdk.queries.useListProviders(
    page,
    limit,
    status,
    search,
    country,
    currency,
    integrationMethod,
    paymentMethod,
    industry,
    isDeleted,
    { enabled, placeholderData: keepPreviousData },
  );
